import React from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "pages/HomePage/HomePage";
import CareersPage from "pages/CareersPage/CareersPage";
import AboutPage from "pages/AboutPage/AboutPage";
import PrivacyPolicyPage from "pages/PrivacyPolicyPage/PrivacyPolicyPage";
import HowWeCanHelpPage from "pages/HowWeCanHelpPage/HowWeCanHelpPage";
import Error from "pages/ErrorPage/ErrorPage";
import { PAGES } from "constants/pages";
import OurWorkPage from "pages/OurWorkPage/OurWorkPage";
import CaseStudyInspectMasterPage from "pages/CaseStudyInspectMaster/CaseStudyInspectMaster";
import CaseStudyHAAPage from "pages/CaseStudyHAA/CaseStudyHAA";
import CaseStudyFinancialEnginePage from "pages/CaseStudyFinancialEngine/CaseStudyFinancialEngine";
import CaseStudyBIHealthcareSolutionPage from "pages/CaseStudyBIHealthcareSolution/CaseStudyBIHealthcareSolution";
import CaseStudyMedullaPage from "pages/CaseStudyMedulla/CaseStudyMedulla";
import CaseStudyAIAnomalyDetectionPage from "pages/CaseStudyAIAnomalyDetection/CaseStudyAIAnomalyDetection";
import CaseStudySlichkaPage from "pages/CaseStudySlichka/CaseStudySlichka";
// import CareersInternFullstackDeveloper from "pages/CareersInternFullstackDeveloper/CareersInternFullstackDeveloper";
// import CareersFullstackDeveloper from "pages/CareersFullstackDeveloper/CareersFullstackDeveloper";

const AppRoutes = () => (
  <Routes>
    <Route errorElement={<Error />}>
      <Route path={PAGES.HOME.route} element={<HomePage />} />
      <Route path={PAGES.BASE.route} element={<HomePage />} />
      <Route path={PAGES.CAREERS.route} element={<CareersPage />} />
      <Route path={PAGES.ABOUT.route} element={<AboutPage />} />
      <Route path={PAGES.CASE_STUDIES.route} element={<OurWorkPage />} />
      <Route
        path={PAGES.CASE_STUDY_INSPECT_MASTER.route}
        element={<CaseStudyInspectMasterPage />}
      />
      <Route path={PAGES.CASE_STUDY_HAA.route} element={<CaseStudyHAAPage />} />
      <Route
        path={PAGES.CASE_STUDY_FINANCIAL_ENGINE.route}
        element={<CaseStudyFinancialEnginePage />}
      />
      <Route
        path={PAGES.CASE_STUDY_BI_HEALTHCARE_SOLUTION.route}
        element={<CaseStudyBIHealthcareSolutionPage />}
      />
      <Route
        path={PAGES.CASE_STUDY_MEDULLA.route}
        element={<CaseStudyMedullaPage />}
      />
      <Route
        path={PAGES.CASE_STUDY_AI_ANOMALY_DETECTION.route}
        element={<CaseStudyAIAnomalyDetectionPage />}
      />
      {/* <Route
        path={PAGES.CAREERS_INTERN_FULL_STACK_DEVELOPER.route}
        element={<CareersInternFullstackDeveloper />}
      />
      <Route
        path={PAGES.CAREERS_FULL_STACK_DEVELOPER.route}
        element={<CareersFullstackDeveloper />}
      /> */}
      <Route
        path={PAGES.CASE_STUDY_SLICHKA.route}
        element={<CaseStudySlichkaPage />}
      />
      <Route path={PAGES.CONTACT.route} element={<AboutPage />} />
      <Route
        path={PAGES.HOW_WE_CAN_HELP.route}
        element={<HowWeCanHelpPage />}
      />
      <Route
        path={PAGES.PRIVACY_POLICY.route}
        element={<PrivacyPolicyPage />}
      />
    </Route>
  </Routes>
);

export default AppRoutes;
